import apiClient from './api'

export const developerService = {
  /**
   * Get developer status
   * @returns {Promise<Object>} Developer status response
   */
  async getStatus() {
    const response = await apiClient.get('/developer')
    return response.data
  },

  /**
   * Get N8N developer information
   * @returns {Promise<Object>} N8N developer response
   */
  async getN8NStatus() {
    const response = await apiClient.get('/developer/n8n')
    return response.data
  },

  /**
   * Get MongoDB connection status and database information
   * @returns {Promise<Object>} MongoDB status response
   */
  async getMongoStatus() {
    const response = await apiClient.get('/developer/mongo')
    return response.data
  },

  /**
   * Check if JWT_SERVICE_TOKEN exists
   * @returns {Promise<Object>} Service token check response
   */
  async checkServiceToken() {
    const response = await apiClient.get('/developer/service-token/check')
    return response.data
  },

  /**
   * Generate a new service token (only if JWT_SERVICE_TOKEN doesn't exist)
   * @returns {Promise<Object>} Service token generation response
   */
  async generateServiceToken() {
    const response = await apiClient.post('/developer/service-token/generate')
    return response.data
  }
} 